/**
* In this file use to create Desktop Notification
**/
import { useState, useEffect } from 'react';

const PushNotificationsService = () => {
	//Intial state declaraction
  const [permission, setPermission] = useState('default');
  

//Service Initialize function
  useEffect(() => {
    setPermission(isSupported() ? 'default' : 'denied');
  }, []);

  const isSupported = () => {
    return 'Notification' in window;
  };
  
  //To set Notification permission
  const requestPermission = () => {
    if ('Notification' in window) {
      Notification.requestPermission(function (status) {
        setPermission(status);
      });
    }
  };
 
 /** 
 * This function used To create Notification
 * @title pass the header content of the Desktop Notification
 * @Options pass the Options values like icons details
 **/
  const create = (title, options) => {
    return new Promise((resolve, reject) => {
      if (!('Notification' in window)) {
        console.log('Notifications are not available in this environment');
        resolve();
      }
      if (permission !== 'granted') {
        console.log("The user hasn't granted you permission to send push notifications");
        resolve();
      }
      let _notify = new Notification(title, options);
      _notify.onshow = function (e) {
        resolve({ notification: _notify, event: e });
      };
      _notify.onclick = function (e) {
		  resolve({ notification: _notify, event: e });
		};
      _notify.onerror = function (e) {
        reject({ notification: _notify, event: e });
      };
      _notify.onclose = function () {
        resolve();
      };
    });
  };

 /**
 * This function used to arrange all the need details
 * @source we pass title,alertContent
 **/
  const generateNotification = (source) => {
    source.forEach((item) => {
      let options = {
        body: item.alertContent,
        icon: "assets/img/nurture-logo-1.png",
      };
      if (item.title) {
         create(item.title, options).then();
      } else {
         create(' ', options).then();
      }
    });
  };

  return {
    permission,
    isSupported,
    requestPermission,
    create,
    generateNotification,
  };
};

export default PushNotificationsService;
